export const downloadFile = (url: string, name?: string) => {
	const link = document.createElement("a");
	link.href = url;
	if (name) {
		// link.setAttribute("download", name);
		link.download = name;
	}
	document.body.appendChild(link);
	link.click();
	link.parentNode?.removeChild(link);
};
export const blobToUrl = (blob: Blob) => {
	var urlCreator = window.URL || window.webkitURL;
	var url = urlCreator.createObjectURL(blob);
	return url;
};

export async function downloadFileFetch(url: string, fileName: string) {
	// Fetch the PDF file
	fetch(url)
		.then((response) => response.blob())
		.then((blob) => {
			// Create a link element
			var link = document.createElement("a");

			// Create a blob URL from the fetched blob
			var blobUrl = window.URL.createObjectURL(blob);

			// Set the download attribute with the desired file name
			link.download = fileName;

			// Set the href attribute to the blob URL
			link.href = blobUrl;

			// Append the link element to the document body
			document.body.appendChild(link);

			// Trigger a click on the link element to start the download
			link.click();

			// Remove the link element and revoke the blob URL
			document.body.removeChild(link);
			window.URL.revokeObjectURL(blobUrl);
		})
		.catch((error) => console.error("Error fetching the PDF:", error));
}
